import type { IconProps } from '../types/IconProps.ts';
export const LayoutKanban: IconProps = {
    name: 'LayoutKanban',
    children: [
        `<path d="M4 4h6M14 4h6" />`,
        `<rect width="6" height="12" x="4" y="8" rx="2" />`,
        `<rect width="6" height="6" x="14" y="8" rx="2" />`,
    ]
};